import { Injectable, signal } from '@angular/core';

const ACTIVATION_EVENTS = ['click', 'pointerdown', 'keydown', 'touchend'] as const;

@Injectable({
  providedIn: 'root',
})
export class UserActivationService {
  readonly #activated = signal(false);
  readonly activated = this.#activated.asReadonly();

  readonly #abortController = new AbortController();
  #resolveActivation!: () => void;
  readonly #activationPromise = new Promise<void>((resolve) => {
    this.#resolveActivation = resolve;
  });

  #hasBoundOnce = false;

  constructor() {
    for (const event of ACTIVATION_EVENTS) {
      document.addEventListener(event, this.#onUserActivation, {
        once: true,
        capture: true,
        signal: this.#abortController.signal,
      });
    }
  }

  /** Returns a promise that resolves once the user has interacted with the page. Resolves immediately if already activated. */
  waitForActivation(): Promise<void> {
    return this.#activationPromise;
  }

  get hasBoundOnce(): boolean {
    return this.#hasBoundOnce;
  }

  markBoundOnce(): void {
    this.#hasBoundOnce = true;
  }

  #onUserActivation = (): void => {
    this.#activated.set(true);
    this.#resolveActivation();
    this.#abortController.abort();
  };
}
